import React from "react";
import clsx from "clsx";

interface SpinnerProps {
  size?: number;
  className?: string;
  color?: string; // Kept this to support existing usage in Home.tsx/Login.tsx
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 24,
  className,
  color,
}) => {
  // Logic to handle the 'color' prop if passed
  // If 'color' is passed as 'white', we apply it as a style so 'currentColor' picks it up.
  // Otherwise default to the brand orange class.
  let colorClass = "text-orange-600"; 
  let style: React.CSSProperties = {};

  if (color) {
    if (color.startsWith("text-")) {
        colorClass = color;
    } else {
        // Assume it's a raw CSS color (like "white")
        colorClass = ""; // Remove default class so style takes precedence
        style.color = color;
    }
  }

  return (
    <svg
      className={clsx("animate-spin", colorClass, className)}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
};